import { verifyLogin, logout, getTokenApi, refreshTokenApi } from '@/api/auth';
import { $Cookies, LoadingOptions } from '@/utils';
import { Loading, Message } from 'element-ui';


let LoadingInstance = {};
let retryLimit = 3;

const authStore = {
  namespaced: true,
  actions: {
    verifyLogin: () => {
      return new Promise(resolve => {
        verifyLogin().then(data => {
          if (data.success) {
            data = data.result;
            $Cookies.set('uid', data.uid);
            $Cookies.set('username', data.username);
            resolve({ isLogged: true, userName: data.username });
          } else {
            $Cookies.remove('uid');
            $Cookies.remove('username');
            resolve({ isLogged: false });
          }
        });
      });
    },
    logout: () => {
      return new Promise((resolve, reject) => {
        logout().then(data => {
          if (data.success) {
            if (data.result.result === 'success') {
              resolve({ isLogout: true });
              $Cookies.remove('uid');
              $Cookies.remove('username');
            }
          } else {
            reject({ isLogout: false, msg: data.errorMsg });
          }
        });
      });
    },
    setUserInfo: ({ commit }, data) => {
      return new Promise(resolve => {
        $Cookies.set('uid', data.uid);
        $Cookies.set('username', data.username);
        resolve();
      });
    },
    getToken: () => {
      LoadingInstance = Loading.service(LoadingOptions);
      $Cookies.remove('authToken');
      $Cookies.remove('refresh_token');

      getTokenApi().then(data => {
        LoadingInstance.close();
        if (data.success) {
          const { refresh_token, token } = data.result;
          $Cookies.set('authToken', token);
          $Cookies.set('refresh_token', refresh_token);
          window.location.reload();
        } else {
          LoadingInstance.close();
          Message.error('获取页面标识失败，请稍后刷新重试！');
        }
      }).catch(()=>{
        LoadingInstance.close();
        Message.error('获取页面标识失败，请稍后刷新重试！');
      });
    },
    refreshToken: ({ dispatch }) => {
      let _refreshToken;
      if (retryLimit <= 3 && retryLimit >= 0) {
        LoadingInstance = Loading.service(LoadingOptions);
        _refreshToken = setTimeout(function () {
          retryLimit--;
          refreshTokenApi().then(data => {
            if (data.success) {
              LoadingInstance.close();
              clearTimeout(_refreshToken);
              const { refresh_token, token } = data.result;
              $Cookies.set('authToken', token);
              $Cookies.set('refresh_token', refresh_token);
              window.location.reload();
            } else {
              dispatch('refreshToken');
            }
          }).catch(err => {
            dispatch('refreshToken');
          });
        }, 3000);
      }
    }
  }
};

export default authStore;
